<template>
  <div class="header">
    <h1>微信管理平台</h1>
  </div>
</template>

<style>
.header {
  height: 100%;
  display: flex;
  color: #fff;
  align-items: center;
}
</style>
